import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apis } from '../../api/apiUrl'
import axios from 'axios'

// Create an async thunk
export const fetchHomepageData = createAsyncThunk(
  'fetchHomepageData',
  async () => {
    const response = await axios.get(
      `${apis.umbraco_delivery_api}/Homepage?fields=properties%5B%24all%5D`
    )
    const data = await response.data
    return data
  }
)

// Create a slice
const homepageSlice = createSlice({
  name: 'homepage',
  initialState: {
    isLoading: false,
    data: null
  },
  extraReducers: builder => {
    builder.addCase(fetchHomepageData.pending, state => {
      state.isLoading = true
    })
    builder.addCase(fetchHomepageData.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchHomepageData.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isLoading = false
    })
  }
})

export default homepageSlice.reducer
